<template>
  <div>
    <div class="tway-headline-2 tway-morado--text text-center mb-5">
      Socios estratégicos y alianzas
    </div>
    <v-carousel cycle height="100px" hide-delimiters :show-arrows="false">
      <v-carousel-item
        href="https://www.liderbciserviciosfinancieros.cl"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-ssff.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.symbiose.cl/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-symbiose-footer.svg')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="http://redchtransformaciondigital.com/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-red-footer.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.getabstract.com/es/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-getabstract-footer.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.openbeauchef.cl/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="
            require('@/assets/images/partners/logo-open-beauchef-footer.png')
          "
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.recreotech.com/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-recreotech-footer.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="http://www.innmetrics.cl/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-inmetrics-footer.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.chileconverge.cl/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-chile-converge.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.sonda.com/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/logo-sonda-footer.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
      <v-carousel-item
        href="https://www.emprendetumente.org/"
        target="_blank"
        :ripple="false"
        class="px-14"
      >
        <v-img
          :src="require('@/assets/images/partners/EtM.png')"
          max-height="80"
          contain
        />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
  export default {
    name: "Partners",
  };
</script>
